import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Blgaumtorenabennurcab() {



    const cardData = {




keyword: "Belgaum to Ranebennur Cab",

headingDescription: "Belgaum Taxi Service offers dependable and comfortable Belgaum to Ranebennur cab services for business travel, family trips, corporate travel, educational visits, medical appointments, sightseeing, and outstation journeys across Karnataka. Whether you require a one-way taxi or a round-trip cab from Belgaum to Ranebennur, we provide safe, affordable, and hassle-free transportation with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, Tempo Traveller, and premium cars to suit individual travelers, families, corporate clients, and groups. We provide doorstep pickup and drop, flexible departure timings, transparent pricing with no hidden charges, easy online booking, and 24/7 customer assistance to ensure a comfortable travel experience. Belgaum Taxi Service is the preferred choice for travelers visiting Ranebennur for business meetings, industrial visits, family functions, educational purposes, and personal travel. With a strong focus on punctuality, customer satisfaction, clean vehicles, and professional service, we ensure every journey between Belgaum and Ranebennur is smooth, secure, and enjoyable.",

topPlaces: [
  {
    title: "Ranebennur",
    description: "Ranebennur is a prominent commercial town in Karnataka known for agriculture, textile trading, educational institutions, and growing business activities. It serves as an important destination for business and family travel."
  },
  {
    title: "Ranebennur Blackbuck Sanctuary",
    description: "Ranebennur Blackbuck Sanctuary is a popular wildlife attraction known for its conservation of blackbucks, grassland ecosystem, birdwatching opportunities, and peaceful natural surroundings."
  },
  {
    title: "Haveri",
    description: "Haveri is a nearby city known for its historical temples, commercial activities, and educational institutions. It is one of the most frequently visited destinations from Ranebennur."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial and industrial hub in North Karnataka with business centers, shopping markets, hospitals, educational institutions, and excellent road connectivity."
  },
  {
    title: "Dharwad",
    description: "Dharwad is widely known for its universities, cultural heritage, educational institutions, and peaceful environment. It is a preferred destination for students, professionals, and families."
  },
  {
    title: "Davanagere",
    description: "Davanagere is a fast-growing commercial city famous for educational institutions, industries, shopping centers, and its popular cuisine, making it a common travel destination from Ranebennur."
  },
  {
    title: "Hampi",
    description: "Hampi, a UNESCO World Heritage Site, is renowned for its magnificent Vijayanagara ruins, ancient temples, stone monuments, and rich cultural heritage, attracting tourists from around the world."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's technology capital, home to leading IT companies, multinational corporations, business parks, shopping malls, and entertainment destinations. Many travelers prefer private cabs for comfortable long-distance journeys."
  },
  {
    title: "Goa",
    description: "Goa is one of India's most popular holiday destinations, famous for beautiful beaches, luxury resorts, vibrant nightlife, Portuguese heritage, water sports, and scenic coastal attractions."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra, known for corporate offices, technology parks, universities, and business centers. It is a popular destination for corporate and family travel from Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Ranebennur Cab",
    "description": "Book Belgaum to Ranebennur Cab for safe, comfortable, and reliable travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, airport transfers, and outstation journeys with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Ranebennur Taxi",
    "description": "Hire Belgaum to Ranebennur Taxi for affordable and hassle-free transportation. Enjoy clean vehicles, professional drivers, transparent pricing, doorstep pickup, and convenient travel for personal, corporate, and family journeys."
  },
  {
    "name": "Belgaum to Ranebennur Cab Service",
    "description": "Choose Belgaum to Ranebennur Cab Service for dependable intercity transportation with comfortable vehicles, punctual service, and skilled chauffeurs. Our taxi services are ideal for business meetings, family vacations, sightseeing, and long-distance travel."
  },
  {
    "name": "Belgaum to Ranebennur Taxi Service",
    "description": "Book Belgaum to Ranebennur Taxi Service for smooth and comfortable travel with reliable drivers, sanitized AC vehicles, and flexible booking options. Travel safely with fixed fare and quality service."
  },
  {
    "name": "Belgaum to Ranebennur One Way Cab",
    "description": "Reserve Belgaum to Ranebennur One Way Cab for economical single-trip travel without return charges. Get affordable fares, comfortable vehicles, and professional chauffeurs for a stress-free journey."
  },
  {
    "name": "Belgaum to Ranebennur One Way Taxi",
    "description": "Choose Belgaum to Ranebennur One Way Taxi for budget-friendly travel with instant booking, clean vehicles, and experienced drivers. Enjoy convenient pickup and safe transportation."
  },
  {
    "name": "Belgaum to Ranebennur Cab Booking",
    "description": "Complete Belgaum to Ranebennur Cab Booking with easy online reservations, instant confirmation, and multiple vehicle options. Select the perfect cab according to your travel requirements and group size."
  },
  {
    "name": "Belgaum to Ranebennur Taxi Booking",
    "description": "Book Belgaum to Ranebennur Taxi Booking services for reliable transportation with affordable pricing and professional chauffeurs. Enjoy flexible travel schedules and comfortable rides."
  },
  {
    "name": "Belgaum to Ranebennur Car Rental",
    "description": "Hire Belgaum to Ranebennur Car Rental with driver for convenient travel solutions. Our rental service is suitable for family outings, business visits, sightseeing, airport transfers, and outstation trips."
  },
  {
    "name": "Belgaum to Ranebennur Outstation Cab",
    "description": "Travel with Belgaum to Ranebennur Outstation Cab offering comfortable long-distance transportation with experienced drivers, well-maintained vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Belgaum to Ranebennur Innova Crysta Cab",
    "description": "Book Belgaum to Ranebennur Innova Crysta Cab for luxury travel with spacious seating, premium interiors, and ample luggage capacity. Perfect for family vacations, group tours, and executive travel."
  },
  {
    "name": "Belgaum to Ranebennur Ertiga Cab",
    "description": "Choose Belgaum to Ranebennur Ertiga Cab for comfortable 6 to 7 seater travel with affordable pricing, AC comfort, and professional chauffeurs for family and corporate journeys."
  },
  {
    "name": "Belgaum to Ranebennur Sedan Cab",
    "description": "Book Belgaum to Ranebennur Sedan Cab for economical and comfortable transportation with clean vehicles and experienced drivers. Suitable for business trips, airport transfers, and personal travel."
  },
  {
    "name": "Belgaum to Ranebennur Round Trip Cab",
    "description": "Reserve Belgaum to Ranebennur Round Trip Cab for flexible return journeys with affordable travel packages, comfortable vehicles, and reliable chauffeur services."
  },
  {
    "name": "Belgaum to Ranebennur Private Taxi",
    "description": "Hire Belgaum to Ranebennur Private Taxi for exclusive travel with dedicated vehicles and experienced drivers. Enjoy privacy, comfort, and customized travel schedules."
  },
  {
    "name": "Cheap Belgaum to Ranebennur Cab",
    "description": "Find Cheap Belgaum to Ranebennur Cab services with competitive fares, reliable vehicles, and professional chauffeurs. Enjoy budget-friendly travel without compromising safety or comfort."
  },
  {
    "name": "Best Belgaum to Ranebennur Cab Service",
    "description": "Choose the Best Belgaum to Ranebennur Cab Service offering premium vehicles, courteous drivers, transparent pricing, and dependable travel solutions for individuals, families, and businesses."
  },
  {
    "name": "Online Belgaum to Ranebennur Cab Booking",
    "description": "Book Online Belgaum to Ranebennur Cab Booking with quick reservations, instant confirmation, and multiple vehicle choices. Enjoy smooth and convenient travel planning."
  },
  {
    "name": "Belgaum to Ranebennur Taxi Fare",
    "description": "Get affordable Belgaum to Ranebennur Taxi Fare with transparent pricing and flexible packages. Choose the vehicle that best suits your travel needs and budget."
  },
  {
    "name": "Belgaum to Ranebennur Car Hire",
    "description": "Hire Belgaum to Ranebennur Car Hire services for comfortable travel with professional drivers and premium vehicles. Ideal for family, business, and leisure trips."
  },
  {
    "name": "Belgaum to Ranebennur Cab Price",
    "description": "Check Belgaum to Ranebennur Cab Price and choose from affordable Sedan, Ertiga, Innova Crysta, and SUV options with flexible booking and quality service."
  },
  {
    "name": "Belgaum to Ranebennur Family Cab",
    "description": "Book Belgaum to Ranebennur Family Cab for spacious and comfortable travel with experienced drivers. Perfect for family vacations, functions, and holiday trips."
  },
  {
    "name": "Belgaum to Ranebennur Corporate Taxi",
    "description": "Choose Belgaum to Ranebennur Corporate Taxi for business travel with punctual service, executive vehicles, and professional chauffeurs for meetings and official visits."
  },
  {
    "name": "Belgaum to Ranebennur Airport Transfer",
    "description": "Book Belgaum to Ranebennur Airport Transfer for timely airport pickup and drop with comfortable AC vehicles, experienced drivers, and dependable transportation services."
  },
  {
    "name": "Belgaum to Ranebennur Cab Fare",
    "description": "Get complete information about Belgaum to Ranebennur Cab Fare with affordable pricing, flexible packages, and multiple cab options for one way and round trips."
  },
  {
    "name": "Belgaum to Ranebennur Taxi Near Me",
    "description": "Find Belgaum to Ranebennur Taxi Near Me for quick taxi availability with reliable drivers and comfortable vehicles. Enjoy safe and convenient travel whenever required."
  },
  {
    "name": "Belgaum to Ranebennur Outstation Taxi",
    "description": "Hire Belgaum to Ranebennur Outstation Taxi for reliable long-distance travel with clean AC vehicles, experienced chauffeurs, and comfortable seating for every journey."
  },
  {
    "name": "Belgaum to Ranebennur Travel by Cab",
    "description": "Travel from Belgaum to Ranebennur by Cab with professional drivers, comfortable vehicles, and flexible travel options. Experience safe, convenient, and enjoyable transportation for business, family, or leisure trips."
  }
],
"tableData": [
  ["Belgaum to Ranebennur Cab", "Belgaum to Ranebennur Taxi"],
  ["Belgaum to Ranebennur Cab Service", "Belgaum to Ranebennur Taxi Service"],
  ["Belgaum to Ranebennur One Way Cab", "Belgaum to Ranebennur One Way Taxi"],
  ["Belgaum to Ranebennur Cab Booking", "Belgaum to Ranebennur Taxi Booking"],
  ["Belgaum to Ranebennur Car Rental", "Belgaum to Ranebennur Outstation Cab"],
  ["Belgaum to Ranebennur Innova Crysta Cab", "Belgaum to Ranebennur Ertiga Cab"],
  ["Belgaum to Ranebennur Sedan Cab", "Belgaum to Ranebennur Round Trip Cab"],
  ["Belgaum to Ranebennur Private Taxi", "Cheap Belgaum to Ranebennur Cab"],
  ["Best Belgaum to Ranebennur Cab Service", "Online Belgaum to Ranebennur Cab Booking"],
  ["Belgaum to Ranebennur Taxi Fare", "Belgaum to Ranebennur Car Hire"],
  ["Belgaum to Ranebennur Cab Price", "Belgaum to Ranebennur Family Cab"],
  ["Belgaum to Ranebennur Corporate Taxi", "Belgaum to Ranebennur Airport Transfer"],
  ["Belgaum to Ranebennur Cab Fare", "Belgaum to Ranebennur Taxi Near Me"],
  ["Belgaum to Ranebennur Outstation Taxi", "Belgaum to Ranebennur Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Effortless Belgaum to Ranebennur Cab Travel",
    WhyChoosedescription: "Whether you're heading for a business assignment, family function, or personal visit, our Belgaum to Ranebennur cab service ensures a relaxed and dependable road journey."
  },
  {
    WhyChooseheading: "Door-to-Door Taxi Convenience",
    WhyChoosedescription: "Skip the hassle of changing buses or trains with direct pickup from any location in Belgaum and drop-off anywhere across Ranebennur."
  },
  {
    WhyChooseheading: "Modern Fleet for Every Journey",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, and premium vehicles to match your travel style and passenger requirements."
  },
  {
    WhyChooseheading: "Designed for Business & Leisure Trips",
    WhyChoosedescription: "From corporate travel and official meetings to family outings and weekend visits, our taxi service adapts to every travel purpose."
  },
  {
    WhyChooseheading: "Comfort on Every Kilometer",
    WhyChoosedescription: "Enjoy clean interiors, air-conditioned vehicles, spacious seating, and experienced chauffeurs who focus on making your trip pleasant."
  },
  {
    WhyChooseheading: "Flexible Booking Options",
    WhyChoosedescription: "Reserve a one-way cab, schedule a same-day return, or book a customized round-trip itinerary based on your travel plans."
  },
  {
    WhyChooseheading: "Professional Service with Transparent Pricing",
    WhyChoosedescription: "Receive clear fare information before your journey, allowing you to travel confidently without unexpected surprises."
  },
  {
    WhyChooseheading: "Fast Booking Confirmation",
    WhyChoosedescription: "Our support team assists with vehicle selection, travel planning, and instant booking confirmation to make your journey stress-free."
  }
]

};

const faqData = [
  {
    question: "Do you provide Belgaum to Ranebennur cab services every day?",
    answer: "Yes, our Belgaum to Ranebennur taxi service operates throughout the week with advance and same-day booking options."
  },
  {
    question: "Can I reserve a one-way taxi to Ranebennur?",
    answer: "Yes, one-way taxi bookings are available along with round-trip and customized travel packages."
  },
  {
    question: "Which cab models are available for this route?",
    answer: "You can book Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium vehicles according to your travel needs."
  },
  {
    question: "Is airport or railway station pickup available in Belgaum?",
    answer: "Yes, pickups can be arranged from Belgaum Airport, Railway Station, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Can I book this cab for corporate travel?",
    answer: "Absolutely. Our taxis are frequently booked for business meetings, official visits, and employee transportation."
  },
  {
    question: "Are family trips comfortable on this route?",
    answer: "Yes, spacious vehicles with ample luggage space are available for families, senior citizens, and group travellers."
  },
  {
    question: "What is included in the taxi fare?",
    answer: "The fare depends on the selected vehicle and travel plan. Tolls, parking, and other applicable charges are shared during booking."
  },
  {
    question: "Can I modify my travel schedule after booking?",
    answer: "Yes, schedule changes can usually be accommodated depending on driver availability and trip timing."
  },
  {
    question: "Do you provide private taxis only?",
    answer: "Yes, all bookings include dedicated vehicles reserved exclusively for your journey."
  },
  {
    question: "How do I book a Belgaum to Ranebennur Cab?",
    answer: "Simply share your pickup location, travel date, preferred vehicle, and passenger details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Manjunath Hiremath",
    feedback: "I travelled to Ranebennur for an official meeting, and everything was perfectly organized. The driver maintained excellent timing, and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepa Kulkarni",
    feedback: "Our family needed a reliable cab for a weekend visit, and the experience exceeded expectations. The vehicle was spotless, spacious, and the journey felt completely relaxed.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Ranebennur Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-ranebennur-cab.webp",
  "description":
    "Book Belgaum to Ranebennur Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Ranebennur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-ranebennur-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Belgaum to Ranebennur Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Ranebennur Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Ranebennur with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Ranebennur Cab, Belgaum to Ranebennur Taxi, Belgaum to Ranebennur Cab Service, Belgaum to Ranebennur Taxi Service, Belgaum to Ranebennur One Way Cab, Belgaum to Ranebennur One Way Taxi, Belgaum to Ranebennur Cab Booking, Belgaum to Ranebennur Taxi Booking, Belgaum to Ranebennur Car Rental, Belgaum to Ranebennur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Blgaumtorenabennurcab;